import { render, staticRenderFns } from "./el-showMore.vue?vue&type=template&id=e0f0d89a&scoped=true"
import script from "./el-showMore.vue?vue&type=script&lang=js"
export * from "./el-showMore.vue?vue&type=script&lang=js"
import style0 from "./el-showMore.vue?vue&type=style&index=0&id=e0f0d89a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0f0d89a",
  null
  
)

export default component.exports